import { render, staticRenderFns } from "./KkmCreateForm.vue?vue&type=template&id=27415094&"
import script from "./KkmCreateForm.vue?vue&type=script&lang=js&"
export * from "./KkmCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports